import { css, Theme } from '@emotion/react';
import { theme } from 'styles/theme/theme';

export const ButtonStyles = (theme: Theme) => css`
  color: ${theme.colors.SurfaceRomanSilver30};

  transition: color 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    color: ${theme.colors.AccentNaplesYellow};
  }
`;
